import { render, staticRenderFns } from "./RailsWeekCalendar.vue?vue&type=template&id=c2b532d4&scoped=true&"
import script from "./RailsWeekCalendar.vue?vue&type=script&lang=js&"
export * from "./RailsWeekCalendar.vue?vue&type=script&lang=js&"
import style0 from "./RailsWeekCalendar.vue?vue&type=style&index=0&id=c2b532d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b532d4",
  null
  
)

export default component.exports